import { render, staticRenderFns } from "./thaiDessert.vue?vue&type=template&id=2af27cf2&scoped=true"
import script from "./thaiDessert.vue?vue&type=script&lang=js"
export * from "./thaiDessert.vue?vue&type=script&lang=js"
import style0 from "./thaiDessert.vue?vue&type=style&index=0&id=2af27cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af27cf2",
  null
  
)

export default component.exports